import React from "react";
import styles from "./view-demo-request.module.css";
import CustomDrawer from "../../../../common/custom-drawer/custom-drawer";
import { Col, Row } from "antd";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../../constants/common";

const ViewDemoRequest = ({
  open,
  onClose,
  selectedDemoData
}) => {
  const details = [
    { label: "Full Name", value: selectedDemoData?.full_name },
    { label: "Email Address", value: selectedDemoData?.email },
    { label: "Phone Number", value: selectedDemoData?.phone_number },
    { label: "Role", value: selectedDemoData?.role },
    { label: "School / Organization Name", value: selectedDemoData?.institution_name },
    { label: "School Type", value: selectedDemoData?.institution_type },
    { label: "Number of Students", value: selectedDemoData?.student_number },
    { label: "Current School Management Software", value: selectedDemoData?.current_school_management_software },
    { label: "Message", value: selectedDemoData?.message },
    {
      label: "Preferable Date",
      value: selectedDemoData?.prefered_demo_date
        ? dayjs(selectedDemoData.prefered_demo_date).format(DATE_FORMAT.DD_MMM_YYYY)
        : "",
    },
    {
      label: "Preferable Time",
      value: selectedDemoData?.prefered_demo_time
        ? dayjs(selectedDemoData.prefered_demo_time, "HH:mm").format("hh:mm A")
        : "",
    },
  ];

  return (
    <CustomDrawer
      title={"View Demo Request"}
      open={open}
      onClose={onClose}
      footer={null}
      width={500}
      className={styles.drawer}
    >
      <div className={styles.detailsContainer}>
        <Row gutter={[0, 8]}>
          {details.map((item, index) => (
            <Col span={24} key={index}>
              <p className={styles.detailItem}>
                <span className={styles.detailLabel}>{item.label}</span>{" - "}
                <span className={styles.detailValue}>
                  {item.value ? item.value : "NA"}
                </span>
              </p>
            </Col>
          ))}
        </Row>
      </div>
    </CustomDrawer>
  );
};

export default ViewDemoRequest;
